export const DEFAULT_MAP_CENTER = [55.980201, 37.187689];
export const DEFAULT_MAP_ZOOM = 14;
export const USER_LOCATION_STORAGE_KEY = 'qc_user_location_v1';

// tile.openstreetmap.org нельзя: серверы OSMF только для osm.org, приложения получают 403.
// osmfr — тот же «классический» OSM-вид с серверов сообщества Франции.
export const TILE_SOURCES = [
  {
    url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    subdomains: ['a', 'b', 'c'],
    maxZoom: 20,
  },
  {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri',
    maxZoom: 19,
  },
];

let warmupStarted = false;
let viewportBound = false;

export function readStoredUserLocation() {
  try {
    const raw = localStorage.getItem(USER_LOCATION_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length !== 2) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveUserLocation(coords) {
  try {
    localStorage.setItem(USER_LOCATION_STORAGE_KEY, JSON.stringify(coords));
  } catch {
    // ignore
  }
}

export function applyTelegramViewport() {
  if (typeof window === 'undefined' || viewportBound) {
    return;
  }
  viewportBound = true;

  const setHeight = (height) => {
    if (!height) {
      return;
    }
    document.documentElement.style.setProperty(
      '--app-height',
      `${Math.round(height)}px`,
    );
  };

  const tg = window.Telegram?.WebApp;
  if (tg?.viewportStableHeight || tg?.viewportHeight) {
    setHeight(tg.viewportStableHeight || tg.viewportHeight);
    tg.onEvent?.('viewportChanged', () => {
      setHeight(tg.viewportStableHeight || tg.viewportHeight);
    });
    return;
  }

  setHeight(window.visualViewport?.height || window.innerHeight);
  window.addEventListener('resize', () => {
    setHeight(window.visualViewport?.height || window.innerHeight);
  });
}

/**
 * Предзагружает Leaflet, не дожидаясь монтирования карты.
 */
export function warmupMap() {
  if (typeof window === 'undefined' || warmupStarted) {
    return;
  }
  warmupStarted = true;

  applyTelegramViewport();
  import('leaflet').catch((error) => {
    console.warn('[Map] Не удалось предзагрузить Leaflet', error);
  });
}
